/* eslint-disable */
<template>
<div>
  <h3 style="text-align:center;color:orange">Five little monkeys学习反馈</h3>
  <div>亲爱的家长，这一周孩子的数字主题内容的学习材料是否有完成呢？<strong style="color:orange">猩球启蒙计划</strong>需要根据您和宝贝对本周学习进展进行<strong style="color:orange">反馈评估</strong>才能为后续提供更加个性化的学习路线和规划，温馨提示：<strong>孩子行为反馈部分需要家长给孩子提问哟</strong>! 完成以下问题会花费您<strong>3-5分钟</strong>时间: </div>
  <div style="color:#3f3f3f;font-size: 12px;color: #888888;">--------------------------------------------------------------------------------------------</div>

  <div><h4 style="text-align:center;color:orange">孩子表现反馈</h4></div>
  <div v-for="(ques, index) in questions" v-bind:key="index">
    <div style=" width:20px; height:20px; background-color:orange; border-radius:10px;">
      <span class="ques_order">{{index+1}}</span>
    </div>
    <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
  </div>

  <div><h4 style="text-align:center;color:orange">家长表现反馈</h4></div>
  <div v-for="(ques, index) in questions_parent" v-bind:key="index">
    <div style=" width:20px; height:20px; background-color:orange; border-radius:10px;">
      <span class="ques_order">{{index+1}}</span>
    </div>
    <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
  </div>


  <div style="text-align:center; margin-top: 10px; color:orange">
    <button @click="submit" :disabled="!isCompleteAnswer" style="color:white;font-size:16pt;background-color:orange;border-color:orange">提交</button>
  </div>
</div>
</template>

<script>
import Question from '@/components/template/question/Question'

export default {
  name: 'FeedbackFlm',
  components: {Question},
  data () {
    return {
      questions: [
        {id: 1, type: 1, body: '孩子是否可以在无帮助的情况下用英文表演和复述整个故事? *', options: ['是', '否']},
        {id: 2, type: 1, body: '孩子可以在家长扮演其中一个角色情况下，用英文表演整个故事情节? *', options: ['是', '否']}, // date
        {
          id: 3,
          type: 1,
          body: '孩子还不能用英文复述故事，但能说其中的1-2个核心句子,包括不限于"five little monkeys jumping on the bed/one fell off and bumped his head/no more monkeys jumping on the bed" *',
          options: ['是', '否']},
        {
          id: 4,
          type: 1,
          body: '孩子还不能说英文句子，但是蹦一些单词，包括不限于"one/two/three/four/five/monkeys/jumpping/bed/head/"*',
          options: ['是','否']
        },
        {
          id: 5,
          type: 1,
          body: '孩子能够用英文顺序和逆序数1-5的数字? *',
          options: ['是','否']
        },
        {
          id: 6,
          type: 1,
          body: '孩子能够说出故事中男猴子和女猴子的数量，并比较数量的多少(答案：3男2女猴，通过发夹颜色辨别) *',
          options: ['是','否']
        },
        {
          id: 7,
          type: 1,
          body: '孩子能够对依次掉落的五只猴子原始的顺序进行排序(答案：1，5，4，2，3) *',
          options: ['是','否']
        },
        {
          id: 8,
          type: 1,
          body: '孩子能够数数身上的鼻子、眼睛、耳朵、手臂、手指的个数，并能够对身上器官的数量进行排序 *',
          options: ['是','否']
        },
        {
        id: 9,
        type: 1,
        body: '孩子能够自评自己对这个故事的理解和掌握程度，询问小朋友是否可以教其他小朋友一起玩这个绘本故事？ *',
        options: ['是','否']
        },
        {
        id: 10,
        type: 1,
        body: '孩子对故事也不感兴趣，没有积极完成手工的制作 *',
        options:['是','否']
        },
      ],
      questions_parent: [
        {id: 11, type: 1, body: '您是否给孩子阅读了这个绘本（能力不允许的条件下，开着音视频跟孩子一起指读也算）? *', options: ['是', '否']},
        {id: 12, type: 1, body: '您是否跟孩子一起制作了本周主题相关的绘本手工？ *', options: ['是', '否']}, // date
        {id: 13, type: 1, body: '您是否陪孩子一起演绎了整个绘本故事？*', options: ['是', '否']},
        {id: 14, type: 1, body: '您对本周的学习材料评分几分？ *', options: ['1','2','3','4','5']},
        {id: 15, type: 0, body: '对于本周的学习方法或材料，您有什么其他意见或建议吗？*'}, // slider
        ],
      answers: {},
      isCompleteAnswer: false
    }
  },
  methods: {
    getAnswer: function (qid, ans) {
      this.answers[qid] = ans
      this.checkAnswer()
    },
    submit: function () {
      console.table('The lastest answer: ')
      console.table(this.answers)
      this.$router.push({path: '/target'})
    },
    checkAnswer: function () {
      let ques_list = this.question.concat(this.questions_parent)
      for (let i = 0; i < this.ques_list.length; i++) {
        let qid = this.ques_list[i].id
        let ans = this.answers[qid]
        if (ans === undefined || ans.length === 0) {
          console.log('Question ' + qid + ' is not answered!')
          this.isCompleteAnswer = false
          return
        }
      }
      this.isCompleteAnswer = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ques_order{
  height:20px;
  line-height:20px;
  display:block; color:#FFF;
  text-align:center;
  font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedbackFiveLittleMonkeys.vue